import { z } from "zod";

import {
  isPasswordRuleValid,
  PASSWORD_RULE_LIST,
} from "@/src/utils/data/passwordRules";

import type { TFunction } from "i18next";

function createEmailField(t: TFunction): z.ZodType<string, string> {
  return z
    .string()
    .min(1, t("errorEmptyEmail"))
    .pipe(z.email(t("errorValidationEmail")));
}

export function createLoginSchema(t: TFunction) {
  return z.object({
    email: createEmailField(t),
    password: z.string().min(1, t("errorEmptyPassword")),
  });
}

export function createResetPasswordSchema(t: TFunction) {
  return z.object({
    email: createEmailField(t),
  });
}

export function createOtpSchema(t: TFunction) {
  return z.object({
    otpToken: z.string().min(1, t("errorEmptyOtp")),
  });
}

export function createNewPasswordSchema(t: TFunction) {
  return z.object({
    password: z
      .string()
      .refine(
        (password) =>
          PASSWORD_RULE_LIST.every((rule) =>
            isPasswordRuleValid(password, rule),
          ),
        t("errorPasswordRules"),
      ),
  });
}

export type LoginFormValues = z.infer<ReturnType<typeof createLoginSchema>>;
export type ResetPasswordFormValues = z.infer<
  ReturnType<typeof createResetPasswordSchema>
>;
export type OtpFormValues = z.infer<ReturnType<typeof createOtpSchema>>;
export type NewPasswordFormValues = z.infer<
  ReturnType<typeof createNewPasswordSchema>
>;
